import { gql } from 'graphql-request';

export const SEND_TO_HIIKER_APP = gql`
  mutation SendToHiikerApp($klass: String!, $id: ID!) {
    sendToHiikerApp(input: { klass: $klass, id: $id }) {
      status
    }
  }
`;
